import { FC } from "react";

import { getFaviconUrl } from "../../../../utils/favicon/getFaviconUrl";
import { getDomainFromUrl } from "../../../../utils/url/getDomainFromUrl";
import type { SourceDetailLinksTableProps } from "./types";

import styles from "./SourceDetailLinksTable.module.css";

const SourceDetailLinksTable: FC<SourceDetailLinksTableProps> = ({
  links,
  indexOffset = 0,
}) => (
  <table
    className={styles["source_detail_links_table"]}
    aria-label="Source links"
  >
    <thead className={styles["source_detail_links_table__thead"]}>
      <tr className={styles["source_detail_links_table__header_row"]}>
        <th>#</th>
        <th>URL</th>
        <th>Mentioned</th>
        <th>Used</th>
        <th>Citations</th>
      </tr>
    </thead>
    <tbody className={styles["source_detail_links_table__body"]}>
      {links.map((row, i) => {
        const domain = getDomainFromUrl(row.url);
        const logoUrl = getFaviconUrl(domain);
        return (
          <tr key={row.id}>
            <td>{indexOffset + i + 1}</td>
            <td>
              <div className={styles["source_detail_links_table__source"]}>
                <div className={styles["source_detail_links_table__logo"]}>
                  {logoUrl ? (
                    <img src={logoUrl} alt="" />
                  ) : (
                    <span>
                      {(domain || "—").slice(0, 2).toUpperCase()}
                    </span>
                  )}
                </div>
                <div className={styles["source_detail_links_table__content"]}>
                  {row.title ? (
                    <span className={styles["source_detail_links_table__title"]}>
                      {row.title}
                    </span>
                  ) : null}
                  <a
                    href={row.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles["source_detail_links_table__url_link"]}
                  >
                    {row.url}
                  </a>
                </div>
              </div>
            </td>
            <td>{row.is_mentioned ? "Yes" : "No"}</td>
            <td>{row.user}</td>
            <td>{row.citations}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
);

export default SourceDetailLinksTable;
